enum EXTERNAL_USER_CONTRACT_ROLES {
  PrimaryBuyer = 1,
  PrimarySeller = 2,
  SecondaryBuyer = 3,
  SecondarySeller = 4,
}

export default EXTERNAL_USER_CONTRACT_ROLES;
